<template>
  <page @click="() => batchSetData = ''">
    <module :title="id ? '编辑APP版本' : '添加APP版本'">
        <c-form ref="form">
            <c-form-item type="hidden" name="id"></c-form-item>
            <c-form-item type="radio" v-model="systemTypeDate" label="终端类型" name="system" :options="systemTypeName" required></c-form-item>
            <c-form-item type="radio" v-model="versionTypeDate" label="版本类型" name="version_type" :options="versionTypeName" required></c-form-item>
            <c-form-item type="radio" v-model="appTypeDate" label="所属项目" name="app_type" :options="appTypeName" required></c-form-item>
	        <c-form-item v-model="appFileUrl" v-show="systemTypeDate != 'IOS'||versionTypeDate==1"  type="file" label="上传文件" name="app_url" file-word="请选择APP安装包"></c-form-item>
            <c-form-item type="input" label="版本号" name="version" required :readonly="version_r" :word="version_word"></c-form-item>
            <c-form-item type="input" label="版本代号" name="version_code" :readonly="version_code_r" :word="version_word" required></c-form-item>
            <c-form-item type="input" label="接口版本号" name="project_version" required></c-form-item>
			<c-form-item type="textarea" label="更新内容" name="remark" required></c-form-item>
        </c-form>
      <template slot="button">
        <c-button size="m" @click="submit(2)">提交保存</c-button>
      </template>
    </module>
  </page>
</template>

<script>
export default {
  name: 'app_version_edit',
  data() {
    return {
           version_r: true,
           version_code_r: true,
           version_word: '安装包上传后自动填充',
           systemTypeName: [
                {name: 'IOS',value: 'IOS'},
                {name: 'Android',value: 'ANDROID'}
           ],
           versionTypeName: [
                {name: '内测',value:1},
                {name: '公测',value: 2}
           ],
           appTypeName: [
                {name: '批发平台APP',value:10}
           ],
           appTypeDate:10,
           systemTypeDate:'IOS',
           versionTypeDate:1,
           appFileUrl:''

    }
  },
  props: {
    id: String
  },
  computed: {

  },

  watch: {
    id() {
        this.getDetail();
    },
    appFileUrl(val){
         if(val && val!=''){
              this.recognitionAPP();
         }else{
              var dd = {};
              dd.version = '';
              dd.version_code = '';
              this.$refs.form.set(dd);
         }
    },
    systemTypeDate(val){
         this.changeParams();
    },
    versionTypeDate(val){
         this.changeParams();
    }
  },

  mounted() {
        if (this.id) {
            this.getDetail();
        }
  },
  methods: {
    /**加载详情**/
    getDetail() {
      this.request({
        url:'/app/version/detail',
        data: {
          version_id: this.id
        },
        loading: true,
        success: data => {
          this.appFileUrl = '';
          this.$refs.form.set(data);
        }
      });
    },
    /**上传完成，解析APP信息**/
    recognitionAPP() {
      this.request({
        url:'/app/version/info',
        data: {
          url_path: this.appFileUrl
        },
        loading: true,
        success: data => {
            this.$refs.form.set(data);
        }
      });
    },
    /*****提交数据******/
    submit() {
           let submitUrl = '/app/version/add';
           if(this.id && this.id > 0){
               submitUrl = '/app/version/edit';
           }
           var submit_obj = this.$refs.form.serialize();
           this.request({
                   url:submitUrl,
                   data:submit_obj,
                    success: data => {
                        this.$message({
                            text: '保存成功'
                        });
                        //刷新列表
                        this.$bus.$emit('app_version_list.update', {});
                        //关闭当前页面
                        this.redirectTo('/app_version');
                    }
           });
    },
    /***切换参数**/
    changeParams(){
        if(this.systemTypeDate != 'IOS'|| this.versionTypeDate==1){
            this.version_r = true;
            this.version_code_r = true;
            this.version_word = '安装包上传后自动填充';
       }else{
            this.version_r = false;
            this.version_code_r = false;
            this.version_word = '';
       }
    }
  }
}
</script>